<template>
  <div class="pageMain" :style="{width: mainWidth()}">
    <transition name="fade-page" mode="out-in">
      <router-view v-if="!$route.meta.noCache"></router-view>
    </transition>
    <div v-if="$route.meta.title != '首页'" class="tip">{{version}}</div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      version: 'Copyright © 2024 远望谷(上海)信息技术有限公司',
    }
  },
  methods: {
    mainWidth(){
      if(this.$store.getters.opened) {
        return 'calc(100% - 70px)'
      } else {
        return 'calc(100% - 200px)'
      }
    }
  }
};
</script>

<style scoped>
  .pageMain {
    /*width: calc(100% - 200px);*/
    overflow: auto;
  }

.pageMain .tip{
  color: #a8a4a4;
  font-size: 16px;
  width: 100%;
  text-align: center;
}
</style>
